import React from 'react';
import { Key, Home, Car, Shield, Wrench, Unlock } from 'lucide-react';
import { SiteData } from '../types/data';
import heroBg from '../assets/hero-bg.jpg';
import serviceLock from '../assets/service-lock.jpg';
import serviceCar from '../assets/service-car.jpg';

interface ServicesProps {
  data: SiteData['services'];
}

export const Services = ({ data }: ServicesProps) => {
  const icons = [Home, Key, Car, Shield, Wrench, Unlock];
  const images = [heroBg, serviceLock, serviceCar, null, null, null];

  return (
    <section id="sluzby" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{data.title}</h2>
          <p className="text-lg text-gray-600">
            {data.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.items.map((service, index) => {
            const Icon = icons[index % icons.length];
            const image = images[index];
            
            return (
              <div 
                key={index} 
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow group"
              >
                {image && (
                  <div className="h-48 overflow-hidden">
                    <img 
                      src={image} 
                      alt={service.title} 
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                )}
                <div className="p-8">
                  <div className="w-14 h-14 bg-primary/10 text-primary rounded-xl flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors">
                    <Icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
